/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'pushpin': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M34.727 17.929l-5.657-5.657a1 1 0 1 0-1.414 1.415l.707.707-4.949 4.95c-1.562-1.562-4.242-1.415-6.363.707l4.242 4.242-8.485 8.485-.707 2.121 2.121-.707 8.485-8.485 4.242 4.242c2.122-2.121 2.27-4.802.707-6.363l4.95-4.949.707.707a1.001 1.001 0 0 0 1.414-1.415z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/pushpin.js